module.exports = __webpack_public_path__ + "img/999.18bb9e93.png";